import axios from "axios";
const config = require('../configs/config');
const BASE_URL = config.apiUrl;

export default class PermissionService {
  static sendMail (body) {
    return axios.post(BASE_URL + 'sendMail', body)
  }
}
